import Buymaterial from "../Pages/Buymaterial";
import Info from "../Pages/Info";
import Login from "../Pages/Login";
import Notfound from "../Pages/Notfound";
import Orders from "../Pages/Orders";
import Profile from "../Pages/Profile";
import Rfq from "../Pages/Rfq";
import { BUYMATERIAL, INFO, LOGIN, NOTFOUND, ORDERS,  PROFILE, RFQ } from "./constURL";
import OpenRoutes from "./openRoutes";
import ProtectedRoute from "./ProtectedRoute";

export const globalRoutes = [
  {
    path: BUYMATERIAL,
    element: Buymaterial,
  },
  {
    path: LOGIN,
    element: Login,
    routeType: OpenRoutes,
  },
  {
    path: PROFILE,
    element: Profile,
    routeType: ProtectedRoute,
    children: [
      {
        path: INFO,
        element: Info,
        routeType: ProtectedRoute,
      },
      {
        path: ORDERS,
        element: Orders,
        routeType: ProtectedRoute,
      },
      {
        path: RFQ,
        element: Rfq,
        routeType: ProtectedRoute,
      }
    ]
  },
  {
    path: NOTFOUND,
    element: Notfound,
    routeType: OpenRoutes,
  },

];
